import { Routes } from "@angular/router";
import { ContentControlStudioComponent } from "./content-control-studio.component";
import { ContentControlStudioRootComponent } from "../content-control-studio-root/content-control-studio-root.component";
import { ContentManagerGuard } from "app/js/src/guards/permission.guard";

export const ContentControlStudioRoutes: Routes = [
  {
    path: "content-control/studio",
    component: ContentControlStudioRootComponent,
    children: [
      {
        path: ":id/:mode",
        component: ContentControlStudioComponent,
      },
    ],
  },
];
